import { Typography } from "@kelp-dao/kernel-design-system";
import BaseImage from "@components/BaseImage";

interface InsuredProps {
  variant?: "default" | "tag";
  link?: string;
  onClick?: () => void;
}

const Insured = ({ variant = "default", link, onClick }: InsuredProps) => {
  const isTag = variant === "tag";

  const content = (
    <>
      <Typography
        type="body"
        className={`${
          isTag
            ? "text-[10px] leading-[1.3] font-normal tracking-[0.25px]"
            : "text-[12px] md:text-[16px] leading-[1.5] font-normal"
        } ${
          isTag ? "text-text-primary" : "text-text-secondary"
        } whitespace-nowrap`}
      >
        Insured by{" "}
      </Typography>
      <BaseImage
        src="/assets/vaults/nexus.svg"
        alt="Nexus Mutual"
        width={isTag ? 75 : 120}
        height={isTag ? 15.023 : 20.8}
        className={`object-contain w-20 h-auto ${
          isTag ? "" : "md:w-full md:h-full "
        }`}
      />
    </>
  );

  const baseClasses = `flex items-center justify-center bg-[#DDEFF0] ${
    isTag
      ? "px-2 py-[9.6px] rounded-bl-[16px] rounded-br-[16px] gap-[2px]"
      : "px-3 py-2 rounded-[8px] gap-2"
  }`;

  if (link) {
    return (
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClick}
        className={`${baseClasses} cursor-pointer transition-opacity hover:opacity-80`}
      >
        {content}
      </a>
    );
  }

  return (
    <div className={baseClasses} onClick={onClick}>
      {content}
    </div>
  );
};

export default Insured;
